import StoreIcon from "@redotech/redo-icons/building-01.svg";
import { ArrayStringFilterOperator } from "@redotech/redo-model/views/advanced-filters/array-string-filter";
import { AdvancedFilterType } from "@redotech/redo-model/views/advanced-filters/generic-advanced-filter-data";
import {
  AdvancedTableFilter,
  ArrayStringTableFilter,
} from "@redotech/redo-web/advanced-filters/advanced-filter";

export const OriginStoreFilter = (
  fetcher: (
    { filters }: { filters: AdvancedTableFilter[] },
    signal: AbortSignal,
  ) => Promise<string[]>,
): ArrayStringTableFilter => ({
  type: AdvancedFilterType.ARRAY_TO_STRING,
  itemLabel: "store",
  operators: [
    ArrayStringFilterOperator.ANY_OF,
    ArrayStringFilterOperator.ALL_OF,
    ArrayStringFilterOperator.NONE_OF,
  ],
  data: {
    name: "originStore",
    type: AdvancedFilterType.ARRAY_TO_STRING,
    value: [],
    operator: ArrayStringFilterOperator.ANY_OF,
  },
  Icon: StoreIcon,
  valueFetcher: fetcher,
  dbSearch: false,
  displayName: "Origin store",
});
